// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/Vector_box.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/realization.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/Staff.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/VectorAvatar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/public/payment.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/public/reports.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/public/analytics.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/public/Vector_human.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/public/finance.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/public/money.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/public/VectorBack.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__HrubL {
  width: 15%;
  position: fixed;
  top: 0;
  left: 0;
  background: white;
  padding: 32px 0;
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.Sidebar_avatar__7KAPu {
  border-radius: 50%;
  object-fit: cover;
  display: block;
}

.Sidebar_logo__CVN78 {
  width: 75px;
  margin: 0 auto;
  padding-bottom: 10px;
}

.Sidebar_userInfo__Ql1FZ {
  display: flex;
  padding: 12px 16px;
  margin-bottom: 32px;
  border-bottom: #f0f0f0 solid 1px;
}

.Sidebar_userText__nUrz3{
  padding: 8px 0px 5px 12px;
}

.Sidebar_name__euj4\\+ {
  text-align: left;
  font-weight: bold;
  font-size: 15px;
  position: relative;
}

.Sidebar_products__cUM5A{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_products__cUM5A::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_realization__kt90Q{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_realization__kt90Q::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 20px;
  height: 19px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_staff__lxqyc{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_staff__lxqyc::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-repeat: no-repeat;
}


.Sidebar_account__DDzy2{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_account__DDzy2::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-repeat: no-repeat;
}


.Sidebar_paymentMethods__9WWyV{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_paymentMethods__9WWyV::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_analytics__hlBTl {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_reports__MNONY::before {
  content: '';
  position: absolute;
  left: 0;
  top: -4px;
  width: 21px;
  height: 21px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_reports__MNONY {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_analytics__hlBTl::before {
  content: '';
  position: absolute;
  left: 0;
  top: -4px;
  width: 21px;
  height: 21px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_counterparties__M03HO{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_counterparties__M03HO::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_finance__YzWBK {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_finance__YzWBK::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 18px;
  height: 17px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_sales__o0Unu{
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_sales__o0Unu::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_label__n1xTr {
  font-size: 14px;
  text-align: left;
  color: #777;
}

.Sidebar_menu__lqVL0 button,
.Sidebar_menuTwo__9Ealy button {
  display: block;
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 13.25px 16px;
  font-size: 16px;
  cursor: pointer;
  border-left: 4px solid transparent;
  box-sizing: border-box; /* чтобы border входил в ширину */
}

.Sidebar_active_text__EtfR4{
  color: rgba(29, 135, 82, 1);
}

.Sidebar_menu__lqVL0 button:hover,
.Sidebar_menu__lqVL0 .Sidebar_active__AF0gR {
  background-color: rgba(29, 135, 82, 0.1);
  border-left: 4px solid #2e7d32;
}

.Sidebar_menuTwo__9Ealy button{
  display: block;
  width: 100%;
  background: none;
  border: none;
  text-align: left;
  padding: 13.25px;
  font-size: 16px;
  cursor: pointer;
  border-left: 4px solid transparent;
}

.Sidebar_menuTwo__9Ealy button:hover,
.Sidebar_menuTwo__9Ealy .Sidebar_active__AF0gR {
  background-color: rgba(29, 135, 82, 0.1);
  border-left: 4px solid #2e7d32;
}

.Sidebar_back__ST1C9 {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_back__ST1C9::before {
  content: '';
  position: absolute;
  left: 0;
  top: 2px;
  width: 14.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_storages__CKnNt {
  position: relative;
  padding-left: 24px;
  font-size: 14px;
}

.Sidebar_storages__CKnNt::before {
  content: '';
  position: absolute;
  left: 0;
  top: -1px;
  width: 21.5px;
  height: 19.5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
}

.Sidebar_userInfo__Ql1FZ {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  cursor: pointer;
  padding: 10px;
  border-radius: 8px;
  transition: background 0.2s;
}

.Sidebar_userInfo__Ql1FZ:hover {
  background: rgba(255, 255, 255, 0.1);
}

.Sidebar_dropdown__UTD1i {
  position: absolute;
  top: 70px;
  left: 0;
  background: #fff;
  color: #333;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 10;
}

.Sidebar_dropdownItem__hVdUO {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: none;
  background: none;
  cursor: pointer;
  transition: background 0.2s;
  font-size: 15px;
  color: #333;
}

.Sidebar_dropdownItem__hVdUO:hover {
  background: #f0f0f0;
}

.Sidebar_icon__wQ6Mc {
  font-size: 18px;
  color: #4a4a4a;
}

.Sidebar_userClickArea__h0m6D {
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAAgD;EAChD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAA0C;EAC1C,wBAAwB;EACxB,4BAA4B;AAC9B;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;AAC9B;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAA8C;EAC9C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yDAA4C;EAC5C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAA0C;EAC1C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,kCAAkC;EAClC,sBAAsB,EAAE,iCAAiC;AAC3D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA;;EAEE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,cAAc;EACd,0DAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,aAAa;EACb,cAAc;EACd,yDAA+C;EAC/C,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".sidebar {\n  width: 15%;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: white;\n  padding: 32px 0;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.avatar {\n  border-radius: 50%;\n  object-fit: cover;\n  display: block;\n}\n\n.logo {\n  width: 75px;\n  margin: 0 auto;\n  padding-bottom: 10px;\n}\n\n.userInfo {\n  display: flex;\n  padding: 12px 16px;\n  margin-bottom: 32px;\n  border-bottom: #f0f0f0 solid 1px;\n}\n\n.userText{\n  padding: 8px 0px 5px 12px;\n}\n\n.name {\n  text-align: left;\n  font-weight: bold;\n  font-size: 15px;\n  position: relative;\n}\n\n.products{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.products::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/Vector_box.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.realization{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.realization::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 20px;\n  height: 19px;\n  background-image: url('/public/realization.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.staff{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.staff::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/Staff.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n\n.account{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.account::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/VectorAvatar.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n\n.paymentMethods{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.paymentMethods::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/payment.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.analytics {\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.reports::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -4px;\n  width: 21px;\n  height: 21px;\n  background-image: url('/public/reports.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.reports {\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.analytics::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -4px;\n  width: 21px;\n  height: 21px;\n  background-image: url('/public/analytics.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.counterparties{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.counterparties::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/Vector_human.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.finance {\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.finance::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 18px;\n  height: 17px;\n  background-image: url('/public/finance.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.sales{\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.sales::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/money.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.label {\n  font-size: 14px;\n  text-align: left;\n  color: #777;\n}\n\n.menu button,\n.menuTwo button {\n  display: block;\n  width: 100%;\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 13.25px 16px;\n  font-size: 16px;\n  cursor: pointer;\n  border-left: 4px solid transparent;\n  box-sizing: border-box; /* чтобы border входил в ширину */\n}\n\n.active_text{\n  color: rgba(29, 135, 82, 1);\n}\n\n.menu button:hover,\n.menu .active {\n  background-color: rgba(29, 135, 82, 0.1);\n  border-left: 4px solid #2e7d32;\n}\n\n.menuTwo button{\n  display: block;\n  width: 100%;\n  background: none;\n  border: none;\n  text-align: left;\n  padding: 13.25px;\n  font-size: 16px;\n  cursor: pointer;\n  border-left: 4px solid transparent;\n}\n\n.menuTwo button:hover,\n.menuTwo .active {\n  background-color: rgba(29, 135, 82, 0.1);\n  border-left: 4px solid #2e7d32;\n}\n\n.back {\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.back::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 2px;\n  width: 14.5px;\n  height: 19.5px;\n  background-image: url('/public/VectorBack.png');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.storages {\n  position: relative;\n  padding-left: 24px;\n  font-size: 14px;\n}\n\n.storages::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: -1px;\n  width: 21.5px;\n  height: 19.5px;\n  background-image: url('/public/Vector_box.svg');\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n\n.userInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  position: relative;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 8px;\n  transition: background 0.2s;\n}\n\n.userInfo:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.dropdown {\n  position: absolute;\n  top: 70px;\n  left: 0;\n  background: #fff;\n  color: #333;\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  z-index: 10;\n}\n\n.dropdownItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  transition: background 0.2s;\n  font-size: 15px;\n  color: #333;\n}\n\n.dropdownItem:hover {\n  background: #f0f0f0;\n}\n\n.icon {\n  font-size: 18px;\n  color: #4a4a4a;\n}\n\n.userClickArea {\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__HrubL`,
	"avatar": `Sidebar_avatar__7KAPu`,
	"logo": `Sidebar_logo__CVN78`,
	"userInfo": `Sidebar_userInfo__Ql1FZ`,
	"userText": `Sidebar_userText__nUrz3`,
	"name": `Sidebar_name__euj4+`,
	"products": `Sidebar_products__cUM5A`,
	"realization": `Sidebar_realization__kt90Q`,
	"staff": `Sidebar_staff__lxqyc`,
	"account": `Sidebar_account__DDzy2`,
	"paymentMethods": `Sidebar_paymentMethods__9WWyV`,
	"analytics": `Sidebar_analytics__hlBTl`,
	"reports": `Sidebar_reports__MNONY`,
	"counterparties": `Sidebar_counterparties__M03HO`,
	"finance": `Sidebar_finance__YzWBK`,
	"sales": `Sidebar_sales__o0Unu`,
	"label": `Sidebar_label__n1xTr`,
	"menu": `Sidebar_menu__lqVL0`,
	"menuTwo": `Sidebar_menuTwo__9Ealy`,
	"active_text": `Sidebar_active_text__EtfR4`,
	"active": `Sidebar_active__AF0gR`,
	"back": `Sidebar_back__ST1C9`,
	"storages": `Sidebar_storages__CKnNt`,
	"dropdown": `Sidebar_dropdown__UTD1i`,
	"dropdownItem": `Sidebar_dropdownItem__hVdUO`,
	"icon": `Sidebar_icon__wQ6Mc`,
	"userClickArea": `Sidebar_userClickArea__h0m6D`
};
export default ___CSS_LOADER_EXPORT___;
